export interface VideoTestimonial {
  id: string;
  artistName: string;
  quote: string;
  metric: string;
  videoUrl: string;
  thumbnailUrl?: string;
}

export const videoTestimonials: VideoTestimonial[] = [
  {
    id: 'kaylee-bell',
    artistName: 'Kaylee Bell',
    quote: 'How Kaylee went viral with 31M TikTok views and signed global management with C3',
    metric: '31M+ Views',
    videoUrl: 'https://vimeo.com/1152519041',
  },
  {
    id: 'brian-michael',
    artistName: 'Brian Michael',
    quote: 'How Brian got 500k streams on one song, with no ad spend, triggering the Spotify algorithm',
    metric: '500K+ Streams',
    videoUrl: 'https://vimeo.com/1152518968',
  },
  {
    id: 'jordan-harvey',
    artistName: 'Jordan Harvey',
    quote: 'How Jordan got 10K followers overnight from his music and over 1M streams',
    metric: '1M+ Streams',
    videoUrl: 'https://vimeo.com/759697210',
  },
  {
    id: 'drew-green',
    artistName: 'Drew Green',
    quote: 'How Drew got over 6 million streams on one song (now at 40M!)',
    metric: '40M+ Streams',
    videoUrl: 'https://vimeo.com/1146180939',
  },
  {
    id: 'sam-and-sounds',
    artistName: 'Sam and Sounds',
    quote: 'How Sam got over 1 million streams and triggered the Spotify algorithm',
    metric: '1M+ Streams',
    videoUrl: 'https://vimeo.com/500459980',
  },
  {
    id: 'telco',
    artistName: 'Telco',
    quote: 'How Telco gained over 100k streams on their first release',
    metric: '100K+ Streams',
    videoUrl: 'https://vimeo.com/483224239',
  },
  {
    id: 'emerger',
    artistName: 'Emerger',
    quote: 'How Emerger (now Porcelain Moon) gained over 100k plays on their debut',
    metric: '100K+ Plays',
    videoUrl: 'https://vimeo.com/522846429',
  },
];
